import { AccountFeatures, AppContext } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { FormattedMessage } from "react-intl";
import BulkModal from "../../bulk/modal.component.jsx";
import Checkbox from "../checkbox/checkbox.component.jsx";
import Icon from "../icon/icon.component.jsx";
import SpanWrapper from '../rich-text/feature-protection-wrappers/spanWrapper.component';


class StandardList extends Component {

    constructor(props, context) {
        super(props, context)

        const isArchived = this.isArchivedListing(this.props.searchData)
        this.state = {
            sortable: this.props.sortable || false,
            selectable: (!isArchived && this.props.selectable) || false,
            bulkActions: this.props.bulkActions || {},
            searchData: this.props.searchData || {},
            didSorted: this.props.didSorted || function () { },
            onRowClick: this.props.onRowClick || function () { },
            hasRowClick: !!this.props.onRowClick,
            rowCursor: this.props.onRowClick ? 'pointer' : 'auto',
            headers: this.props.headers || [],
            rows: this.props.rows || [],
            footer: this.props.footer || undefined,
            className: this.props.className || '',
            rowClassName: this.props.rowClassName || '',
            tableClassName: this.props.tableClassName || '',
            footerClassName: this.props.footerClassName || '',
            headerClassName: this.props.headerClassName || '',
            smallLine: this.props.smallLine || false,
            extraSmallLine: this.props.extraSmallLine || false,
            tableContainerStyle: this.props.tableContainerStyle || {},
            tableStyle: this.props.tableStyle || {},
            uniqueId: new Date().getMilliseconds(),
            pageSize: this.props.pageSize || 10,
            totalItemsCount: this.props.totalItemsCount || 0,
            selection: this.formatSelection(this.props.rows || []),
            isChecked: true,
            isEverythingSelected: false,
            modal: '',
            showSelectionSize: this.props.showSelectionSize ?? true,
            customBulkAction: this.props.customBulkAction || null,
            object: this.props.object || ''
        }
        this.triggerSelectAll = this.triggerSelectAll.bind(this)
        this.selectEverything = this.selectEverything.bind(this)
        this.clearSelected = this.clearSelected.bind(this)
        this.onSelectAll = this.props.onSelectAll || function () { }
        this.onRowSelect = this.props.onRowSelect || function () { }
        this.onPageSelect = this.props.onPageSelect || function () { }
        this.onDragEnd = this.onDragEnd.bind(this)
        this.reorder = this.reorder.bind(this)
        this.tableHeadWithEmptyColumn = this.tableHeadWithEmptyColumn.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            sortable: nextProps.sortable || false,
            headers: nextProps.headers || [],
            rows: nextProps.rows || [],
            footer: nextProps.footer || undefined,
            smallLine: nextProps.smallLine || false,
            extraSmallLine: nextProps.extraSmallLine || false,
            className: nextProps.className || '',
            rowClassName: nextProps.rowClassName || '',
            tableClassName: nextProps.tableClassName || '',
            footerClassName: nextProps.footerClassName || '',
            headerClassName: nextProps.headerClassName || '',
            searchData: nextProps.searchData || {},
            bulkActions: nextProps.bulkActions || {},
            pageSize: nextProps.pageSize || 10,
            totalItemsCount: nextProps.totalItemsCount || 0,
            selection: this.formatSelection(nextProps.rows || []),
            tableContainerStyle: nextProps.tableContainerStyle || {},
            tableStyle: nextProps.tableStyle || {},
            customBulkAction: nextProps.customBulkAction || null,
        }, () => {
            this.init()
        })
    }

    formatSelection(rows) {
        let selection = {}
        for (let i in rows) {
            const item = rows[i]
            if (item.hasOwnProperty('selected')) {
                selection[item.rowId] = item.selected
            } else {
                if (!this.state || isNaN(this.state.selection[item.rowId])) {
                    selection[item.rowId] = false
                } else if (!isNaN(this.state.selection[item.rowId])) {
                    selection[item.rowId] = this.state.selection[item.rowId]
                }
            }
        }
        return selection
    }

    componentDidMount() {
        this.init()
    }

    init() {
        if (this.state.sortable) {
            this.didSorted = this.state.didSorted.bind(this)
        }
    }

    isArchivedListing(searchData) {
        if (!searchData) {
            return false
        }
        const filters = searchData.filters || {}
        return filters.isArchived || filters.isArchived?.label || false
    }

    colsCount() {
        let extraCol = this.state.selectable ? 1 : 0
        if (this.state.sortable) {
            extraCol++
        }

        if (this.props.overrideColsCount) {
            return this.props.overrideColsCount + extraCol
        }

        if (Array.isArray(this.state.headers) && this.state.headers.length > 0) {
            return this.state.headers.length + extraCol
        } else if (typeof this.state.headers === 'object' && !Array.isArray(this.state.headers)) {
            return this.state.headers.data.length + extraCol
        } else {
            if (this.state.rows.length > 0) {
                if (typeof this.state.rows[0] === 'object') {
                    return this.state.rows[0].data.length + extraCol
                }
                return this.state.rows[0].length + extraCol
            }
        }
        return 0
    }

    triggerSelectAll(isChecked) {
        const selection = this.state.selection
        for (let i in selection) {
            let row = this.state.rows.find(r => r.rowId === i)
            if (!row || !row.unselectable) {
                selection[i] = isChecked
            }
        }
        this.setState({
            selection: selection,
            isEverythingSelected: false,
        })
        this.onPageSelect(selection)
    }

    selectEverything() {
        this.setState({
            isEverythingSelected: true
        })
        if (this.props.onSelectAll) {
            this.props.onSelectAll(true, this.state.totalItemsCount)
        }
    }

    clearSelected() {
        const selection = this.state.selection
        for (let i in selection) {
            selection[i] = false
        }
        this.setState({
            isEverythingSelected: false,
            selection: selection,
        })
        if (this.props.onSelectAll) {
            this.props.onSelectAll(false, this.state.totalItemsCount)
        }
    }

    isAllChecked() {
        const selection = this.state.selection
        for (let i in selection) {
            let row = this.state.rows.find(r => r.rowId === i)
            if (!selection[i] && row && !row.unselectable) {
                return false
            }
        }
        return true
    }

    isAtLeastOneIsChecked() {
        const selection = this.state.selection
        for (let i in selection) {
            if (selection[i]) {
                return true
            }
        }
        return false
    }

    numberOfItemsSelected() {
        if (this.state.isEverythingSelected) {
            return this.state.totalItemsCount
        }
        return Object.values(this.state.selection).filter(val => val).length
    }

    isRowChecked(id) {
        return this.state.selection[id]
    }

    selectRow(id, isChecked) {
        const selection = Object.assign({}, this.state.selection)
        selection[id] = isChecked
        this.setState({
            selection: selection,
            isEverythingSelected: false,
        }, () => {
            this.onRowSelect(id, isChecked)
        })
    }

    openBulkModal(operationType) {
        return function (event) {
            event.preventDefault()
            let filters = this.state.searchData
            if (!this.state.isEverythingSelected) {
                let contactIds = []
                for (let id in this.state.selection) {
                    if (this.state.selection[id]) {
                        contactIds.push(id)
                    }
                }
                filters.fields = ['_id']
                filters.filters = {
                    _id: contactIds
                }
                filters.keywords = '*'
            }


            if (!this.state.customBulkAction) {
                this.setState({
                    modal: <BulkModal
                        filters={filters}
                        operationType={operationType}
                        numberOfItemsSelected={this.numberOfItemsSelected()}
                        object={this.state.object}
                        onClose={() => {
                            this.setState({ modal: '' })
                        }}
                        onChange={metadata => {
                            this.setState({ metadata: metadata })
                        }} />
                })
            } else (
                this.state.customBulkAction(this.state.selection, this.state.isEverythingSelected)
            )
        }.bind(this)
    }

    onDragEnd(result) {
        if (!result.destination) {
            return;
        }
        const updatedData = this.reorder(
            this.state.rows,
            result.source.index,
            result.destination.index
        )
        this.setState({ rows: updatedData })
        this.didSorted(updatedData)
    }

    reorder(list, start, end) {
        const result = Array.from(list)
        const [removed] = result.splice(start, 1)
        result.splice(end, 0, removed)
        return result
    }

    tableHeadWithEmptyColumn(html) {
        const tempHtml = []
        tempHtml.push("")
        return tempHtml.concat(html)
    }

    render() {
        let footer = undefined
        let footerRows = []
        let footerClassNames = []
        if (this.state.footer && Array.isArray(this.state.footer)) {
            footerRows = this.state.footer
        } else if (typeof this.state.footer === 'object' && Array.isArray(this.state.footer.data)) {
            footerRows = this.state.footer.data || []
            footerClassNames = this.state.footer.classNames || []
        } else if (this.state.footer) {
            footer = <tr>
                <td colSpan={this.colsCount()} className={this.state.footerClassName}>
                    {this.state.footer}
                </td>
            </tr>
        }

        if (footerRows.length > 0) {
            footer = <tr>
                {footerRows.map((content, i) => {
                    const extraClassName = footerClassNames[i] || ''
                    return <td key={i} className={this.state.footerClassName + ' ' + extraClassName}>
                        {content}
                    </td>
                })}
            </tr>
        }


        let header = null
        let headerRows = []
        let headerClassNames = []
        let showSelectionSize = this.props.showSelectionSize || true
        if (Array.isArray(this.state.headers)) {
            headerRows = this.state.headers
        } else if (typeof this.state.headers === 'object') {
            headerRows = this.state.headers.data
            headerClassNames = this.state.headers.classNames || []
        } else {
            header =
                <th key={i} colSpan={this.colsCount()} className="text-secondary border-bottom-0 border-top-0 px-4">
                    {this.state.headers}
                </th>
        }
        if (headerRows.length > 0) {
            if (this.state.selectable) {
                let actions = []
                for (let action in this.state.bulkActions) {
                    actions.push(<a key={actions.length} className="dropdown-item" href="#"
                        onClick={this.openBulkModal(action)}>
                        {this.state.bulkActions[action]}
                    </a>)
                }
                const tempHeaders = []
                tempHeaders.push(<span>
                    <SpanWrapper
                        redirectToAccount={true}
                        accountFeatureKey={AccountFeatures.FeatureBulkOperations}>
                        <Checkbox
                            title={'Select All'}
                            checked={AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureBulkOperations) ? this.isAllChecked() : false}
                            onChange={(isChecked) => {
                                if (AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureBulkOperations)) {
                                    this.triggerSelectAll(isChecked)
                                }
                            }}
                        />
                    </SpanWrapper>
                    {this.isAtLeastOneIsChecked() && showSelectionSize ?
                        <div className={`btn-group position-absolute bg-light pr-5 dropdown`}>
                            <button type="button"
                                className="ml-1 py-0 btn btn-link btn-sm pr-5"
                                data-toggle={'dropdown'}
                                aria-haspopup="true"
                                aria-expanded="false">
                                <Icon value={'layer-group'} className={'mr-1'} />
                                <FormattedMessage
                                    id="common.listing.headers.items_selected_label"
                                    defaultMessage="{count} item(s) selected"
                                    values={{
                                        count: this.numberOfItemsSelected()
                                    }}
                                />
                            </button>
                            <div className="dropdown-menu">
                                {actions}
                            </div>
                        </div> : null}
                </span>)
                headerRows = tempHeaders.concat(headerRows)
            }
            if (this.state.sortable) {
                headerRows = this.tableHeadWithEmptyColumn(headerRows)
            }
            header = <thead className="bg-light">
                <tr>{headerRows.map((header, i) => {
                    let className = "px-4"
                    if (this.state.smallLine) {
                        className = "px-4 py-2"
                    }
                    if (this.state.extraSmallLine) {
                        className = "px-3 py-0"
                    }
                    const extraClassName = headerClassNames[i] || ''
                    return <th key={i}
                        className={"text-secondary border-bottom-0 border-top-0 " + className + " " + this.state.headerClassName + " " + extraClassName}>
                        {header}
                    </th>
                })}</tr>
            </thead>
        }

        let rows = []
        if (this.isAllChecked() && this.state.totalItemsCount > this.state.pageSize) {
            let selectedMessage = <p className={'mb-0 text-center'}>
                <FormattedMessage
                    id="common.listing.selectable.page_selected_message"
                    defaultMessage="All {count} items on this page are selected."
                    values={{
                        count: <strong className={'bigger'}>{this.state.pageSize}</strong>
                    }}
                />
                <button className={'btn btn-sm btn-outline-primary ml-2'} onClick={this.selectEverything}>
                    <FormattedMessage
                        id="common.listing.selectable.select_all_pages_btn"
                        defaultMessage="Select all {count} items"
                        values={{
                            count: <strong className={'bigger'}>{this.state.totalItemsCount}</strong>
                        }}
                    />
                </button>
            </p>
            if (this.state.isEverythingSelected) {
                selectedMessage = <p className={'mb-0 text-center'}>
                    <FormattedMessage
                        id="common.listing.selectable.everything_selected_message"
                        defaultMessage="All {count} items are selected."
                        values={{
                            count: <strong className={'bigger'}>{this.state.totalItemsCount}</strong>
                        }}
                    />
                    <button className={'btn btn-sm btn-outline-primary ml-2'} onClick={this.clearSelected}>
                        <FormattedMessage
                            id="common.listing.selectable.clear_selection_btn"
                            defaultMessage="Clear selection"
                        />
                    </button>
                </p>
            }
            rows.push({
                className: 'bg-light',
                singleColumn: true,
                data: selectedMessage
            })
        }
        rows = rows.concat(this.state.rows)
        return (
            <div className={'ui-has-modules ' + this.state.className}>
                {this.state.modal}
                <div className="col-12 ui-module p-0 mb-0 table-responsive" style={this.state.tableContainerStyle}>
                    <table
                        className={"table mb-0 " + this.state.tableClassName} style={this.state.tableStyle}>
                        {header}
                        <DragDropContext onDragEnd={this.onDragEnd}>
                            <Droppable droppableId="dropable-standard-list">
                                {(provided, snapshot) => (
                                    <tbody ref={provided.innerRef} id={'tbody-' + this.state.uniqueId}>
                                        {rows.map((row, index) => {
                                            let data = []
                                            let classNames = []
                                            let className = ''
                                            let singleColumn = false
                                            let metadata = {}
                                            let rowId = ''
                                            if (Array.isArray(row)) {
                                                data = row
                                            } else if (typeof row === 'object') {
                                                data = row.data
                                                metadata = row.metadata
                                                classNames = row.classNames || []
                                                className = row.className || ''
                                                singleColumn = row.singleColumn || false
                                                rowId = row.rowId || ''
                                            }
                                            if (this.state.selectable && Array.isArray(data)) {
                                                const tempRows = []
                                                tempRows.push(
                                                    !row.unselectable && <SpanWrapper
                                                        accountFeatureKey={AccountFeatures.FeatureBulkOperations}
                                                        showLock={false}
                                                        key={rowId}>
                                                        <Checkbox
                                                            checked={AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureBulkOperations) ? this.isRowChecked(rowId) : false}
                                                            onChange={isChecked => {
                                                                if (AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureBulkOperations)) {
                                                                    this.selectRow(rowId, isChecked)
                                                                }
                                                            }}
                                                            style={{ top: '3px' }} />
                                                    </SpanWrapper>
                                                )
                                                data = tempRows.concat(data)
                                                className += this.isRowChecked(rowId) ? ' line-selected' : ''
                                            }
                                            return (
                                                <Draggable
                                                    isDragDisabled={!this.state.sortable}
                                                    key={this.state.uniqueId + '-' + index}
                                                    draggableId={this.state.uniqueId + '-' + index}
                                                    index={index}
                                                >
                                                    {(provided, snapshot) => (
                                                        <tr ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            className={className}
                                                            id={rowId}
                                                            key={this.state.uniqueId + '-' + index}
                                                        >

                                                            {this.state.sortable &&
                                                                <td style={{ width: '50px' }}>
                                                                    <a href={'#'}
                                                                        {...provided.dragHandleProps}
                                                                        className={'sort-handle'}
                                                                        onClick={e => e.preventDefault()}
                                                                    >
                                                                        <Icon className={"lead"} value={'bars'} />
                                                                    </a>
                                                                </td>
                                                            }

                                                            {singleColumn ? <td colSpan={this.colsCount()}>
                                                                {data}
                                                            </td> : data.map((content, i) => {
                                                                let className = "p-4"
                                                                if (this.state.smallLine) {
                                                                    className = "px-4 py-2"
                                                                }
                                                                if (this.state.extraSmallLine) {
                                                                    className = "px-3 py-0"
                                                                }
                                                                if (this.state.rowClassName) {
                                                                    className = this.state.rowClassName
                                                                }
                                                                const extraClassName = classNames[i] || ''
                                                                return <td key={i}
                                                                    className={className + ' ' + extraClassName}
                                                                    onClick={e => {
                                                                        if (this.state.hasRowClick) {
                                                                            if (metadata && metadata['contactId']) {
                                                                                this.selectRow(rowId, !this.isRowChecked(rowId))
                                                                            }
                                                                            else {
                                                                                e.preventDefault()
                                                                                this.state.onRowClick(metadata)
                                                                            }
                                                                        }

                                                                    }} style={{
                                                                        cursor: this.state.rowCursor,
                                                                    }}>
                                                                    {content}
                                                                </td>
                                                            })}</tr>

                                                    )}
                                                </Draggable>
                                            )
                                        })}
                                        {footer}
                                    </tbody>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </table>
                </div>
            </div>
        )
    }
}

export default StandardList


// WEBPACK FOOTER //
// ./src/common/listing/list.component.jsx